export interface Timer {
    start: () => void;
    tick: () => void;
    stop: () => void;
}

export class TimerUtil {

    public static runCallbackWhenTimerIsIdle(callback: () => void, idleTime = 1000): Timer {
        /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
        let timeoutId: any;
        let started = false;

        return {
            start: () => {
                started = true;
            },
            tick: () => {
                clearTimeout(timeoutId);

                if (started) {
                    timeoutId = setTimeout(callback, idleTime);
                }
            },
            stop: () => {
                started = false;
            }
        };
    }

}
